import { Box } from '@chakra-ui/react';
import reactStringReplace from 'react-string-replace';

export const MentionedName = ({ text }: { text: string }) => {
  // Replace any string after '@' with a <span> element
  const replacedText = reactStringReplace(text, /@(\w+)/g, (match, i) => (
    <Box as="span" color="#000AFF" fontWeight="500" fontSize="sm" key={i}>
      {match}
    </Box>
  ));

  return <div>{replacedText}</div>;
};
